var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgWatch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#666",
  d: "M10.703 7.188a.703.703 0 1 0-1.406 0v2.678c0 .252.135.485.354.61l1.875 1.072a.703.703 0 0 0 .698-1.221l-1.52-.869v-2.27Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#666",
  fillRule: "evenodd",
  d: "M10 2.734a7.266 7.266 0 1 0 0 14.532 7.266 7.266 0 0 0 0-14.532ZM4.14 10a5.86 5.86 0 1 1 11.72 0 5.86 5.86 0 0 1-11.72 0Z",
  clipRule: "evenodd"
})));
export default SvgWatch;